import React from "react";
import PropTypes from "prop-types";
import { TableWithFixedHeader } from "components/Table";
import Button from "components/Button";
import history from "browserHistory";
import Separator from "components/Separator";
import EditButton from "components/EditButton";
import { Row } from "jsxstyle";
import DeleteCMBS from "./DeleteCMBS";
import DuplicateCMBSForm from "./DuplicateCMBSForm";
import columns from "./CMBSTableColumns";
import PermissionValidator from "components/PermissionValidator";
import Modal, { ModalContent } from "components/Modal";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";

function CMBSTable({ data, pending, onSortChange, onReload, sortable }) {
  const [CMBSToDuplicate, setCMBSToDuplicate] = React.useState(null);
  const cmbsTableColumns = JSON.parse(localStorage.getItem("cmbsColumns"));

  const visibleColumns = cmbsTableColumns
    ? cmbsTableColumns.map((column) =>
        columns.find((tableColumn) => tableColumn.title === column),
      )
    : columns;

  return (
    <React.Fragment>
      <TableWithFixedHeader
        pending={pending}
        rowKey="deal_code"
        scroll={{
          x:
            visibleColumns.reduce((acc, column) => acc + column.width, 0) + 240,
        }}
        columns={[
          {
            title: "Deal Code",
            dataIndex: "deal_code",
            key: "deal_code",
            sortable: sortable !== false,
            fixed: "left",
            width: 120,
          },
          ...visibleColumns.map((column) => ({
            ...column,
            sortable: sortable !== false,
          })),
          {
            title: "Actions",
            dataIndex: "",
            key: "actions",
            fixed: "right",
            width: 120,
            render: (item) => (
              <Row>
                <EditButton
                  onClick={() => history.push(`/cmbs/edit/${item.deal_code}`)}
                />
                <PermissionValidator
                  allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}
                  shouldHide
                >
                  <Separator size="xs" />
                  <DeleteCMBS cmbs={item} onDelete={onReload} />
                  <Separator size="xs" />
                  <Button
                    size="sm"
                    icon="duplicate"
                    onClick={() => setCMBSToDuplicate(item)}
                  />
                </PermissionValidator>
              </Row>
            ),
          },
        ]}
        data={data}
        onSortChange={onSortChange}
      />
      <Modal
        visible={CMBSToDuplicate}
        onRequestClose={() => setCMBSToDuplicate(null)}
      >
        <ModalContent>
          <DuplicateCMBSForm
            onDuplicate={onReload}
            onRequestClose={() => setCMBSToDuplicate(null)}
            initialValues={CMBSToDuplicate}
          />
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
}

CMBSTable.propTypes = {
  attribute: PropTypes.bool,
};

CMBSTable.defaultProps = {
  sortable: true,
};

export default CMBSTable;
